import React from 'react';
import styled from 'styled-components';

const BaseInput = styled.input`
  position: relative;
  left: 15px;
  top: -4px;
  z-index: 0;
  -webkit-appearance: none;
  display: none;
  & + label:before {
    width: 15px;
    height: 15px;
    border-radius: 5px;
    border: 2px solid #000;
    background-color: #fff;
    display: block;
    content: '';
    float: left;
    margin-right: 5px;
    z-index: 5;
    position: relative;
    cursor: pointer;
  }
  &:checked + label:before {
    box-shadow: inset 0px 0px 0px 3px #fff;
    background-color: #000;
  }
  & + label {
    cursor: pointer;
    overflow-wrap: anywhere;
  }
`;

/**
 * Styled checkbox wrapper with associated label.
 * @param inputProps - Native checkbox attributes plus label/name.
 * @returns Checkbox control matching widget theme.
 */
const Checkbox = (inputProps: any) => {
  return (
    <>
      <BaseInput type="checkbox" id={inputProps.name} {...inputProps} />
      <label htmlFor={inputProps.name}>{inputProps.label}</label>
    </>
  );
};

export default Checkbox;
